export const sectorRoleOptions = [
  { value: 'm_t', name: 'Подключение и ремонт клиентов' },
  { value: 'grrs', name: 'Ремонт районных сетей' }
];
